export default __webpack_public_path__ + "static/media/api-creation.2fb5001d.png";